/* eslint-disable @typescript-eslint/no-var-requires */
import axios from 'axios';
//import LocalStorageService from "./services/storage/localstorageservice";
import router from '../router';
const parse = require('json-parse-safe');

import Vue from 'vue';

// Ordem: variável do container (public/inject.js), variável do build e endereço padrão.
const runtimeApiBaseURL = ((window as any).variables || {}).API_BASE_URL;
const apiBaseURL =
    (runtimeApiBaseURL && !runtimeApiBaseURL.includes('${') ? runtimeApiBaseURL : '') ||
    process.env.VUE_APP_API_BASE_URL ||
    'https://pbbadvogados-backend-api-242e8cdb5391.herokuapp.com/';
axios.defaults.baseURL = apiBaseURL;

// Add a request interceptor
axios.interceptors.request.use(
    (config) => {
        const data = parse(<any>localStorage.getItem('token'));

        if (data.value) {
            config.headers['Authorization'] = 'Bearer ' + data.value.token;
        }
        // config.headers['Content-Type'] = 'application/json';
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

//Add a response interceptor
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        const originalRequest = error.config;

        if (error.request.status == 0) {
            return Promise.reject(error);
        }

        if (error.response.status === 401 && !originalRequest.url.includes('/login')) {
            localStorage.clear();
            // Consultas opcionais em páginas públicas não devem tirar o visitante da página.
            if (!originalRequest.skipAuthRedirect) router.push('/');
            return Promise.reject(error);
        }

        // if (error.response.status === 419 && !originalRequest._retry) {
        //   originalRequest._retry = true;
        //   const token = parse(<any>localStorage.getItem("token"));

        //   return axios
        //     .get(
        //       `/sessions/${token.value.session}/access/new?access=${token.value.access}`
        //     )
        //     .then((res) => {
        //       if (res.status === 200) {
        //         localStorage.setItem("token", JSON.stringify(res.data.data));
        //         axios.defaults.headers.common["Authorization"] =
        //           "Bearer " + res.data.data.access;
        //       }
        //       return axios(originalRequest);
        //     })
        //     .catch((err) => {
        //       console.error(err);
        //       router.push("/login");
        //       return Promise.reject(error);
        //     });
        // }

        //check error format
        if (error.response.data && 'success' in error.response.data) {
            return Promise.reject(error.response.data);
        }

        return Promise.reject(error);
    }
);

const publicAxios = axios.create({
    baseURL: apiBaseURL
});

Vue.prototype.$publicAxios = publicAxios;
